import { isEmpty } from 'lodash-es';
import { shallow } from 'zustand/shallow';
import { IS_USE_PLEX_API } from '../../../constants';
import { CasinoTypeUnion } from '../../../types';
import { getGames } from '../../../utils';
import { useGamesStore } from '../../store';

export const useGetLobbyCategoryGames = (
  categoryId: string,
  feedName: string,
  casinoType: CasinoTypeUnion
) => {
  return useGamesStore((store) => {
    const categoryGames = IS_USE_PLEX_API
      ? store.lobbies[casinoType]?.categories?.data?.[categoryId]
      : store.feeds[feedName]?.categories?.data?.[categoryId];
    if (isEmpty(categoryGames)) {
      return [];
    }

    return getGames(categoryGames.games, store.games.data);
  }, shallow);
};
